import React from "react";
import { Modal } from "react-bootstrap";

const ShortbookSettingsModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <div className="rounded-2xl bg-white shadow-lg overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center p-3 border-b">
          <div>
            <h4 className="font-bold text-lg text-gray-900">
              Shortbook Settings
            </h4>
            <p className="text-sm text-gray-500">
              Verify & Update the Details Below
            </p>
          </div>

          {/* Right corner buttons */}
          <div className="flex items-center gap-2">
            <button
              className="gradient-button px-4 py-2 text-sm font-medium text-white rounded-lg shadow-sm transition"
            >
              Apply (F2)
            </button>
            <button
              onClick={handleClose}
              className="text-gray-600 hover:text-gray-800 text-2xl leading-none"
            >
              &times;
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="p-4 space-y-3">
          {/* Row 1: MIN & MAX STOCK */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {/* Min Stock */}
            <div>
              <label className="text-sm font-semibold text-gray-700 block mb-1">
                MIN STOCK<span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type="number"
              
                  className="w-full border border-gray-300 rounded-lg pl-3 pr-14 py-2 focus:outline-none focus:ring-1 focus:ring-green-500 font-medium"
                />
                <span className="absolute right-3 top-2.5 text-gray-500 text-sm font-medium">
                  days
                </span>
              </div>
              <p className="text-xs text-gray-400 mt-0.5">
                Value In Number of Days
              </p>
            </div>

            {/* Max Stock */}
            <div>
              <label className="text-sm font-semibold text-gray-700 block mb-1">
                MAX STOCK<span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type="number"
            
                  className="w-full border border-gray-300 rounded-lg pl-3 pr-14 py-2 focus:outline-none focus:ring-1 focus:ring-green-500 font-medium"
                />
                <span className="absolute right-3 top-2.5 text-gray-500 text-sm font-medium">
                  days
                </span>
              </div>
              <p className="text-xs text-gray-400 mt-0.5">
                Max Stock &gt; Min Stock
              </p>
            </div>
          </div>

          {/* Reorder Point */}
          <div>
            <label className="text-sm font-semibold text-gray-700 block mb-1">
              REORDER POINT IN DAYS<span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <input
                type="number"
           
                className="w-full border border-gray-300 rounded-lg pl-3 pr-14 py-2 focus:outline-none focus:ring-1 focus:ring-green-500 font-medium"
              />
              <span className="absolute right-3 top-2.5 text-gray-500 text-sm font-medium">
                days
              </span>
            </div>
            <p className="text-xs text-gray-400 mt-0.5">
              Min Stock ≤ Reorder Point ≤ Max Stock
            </p>
          </div>

          {/* Period for Demand Calculation */}
          <div>
            <label className="text-sm font-semibold text-gray-700 block mb-1">
              PERIOD FOR DEMAND CALCULATION
              <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <input
                type="number"
              
                className="w-full border border-gray-300 rounded-lg pl-3 pr-14 py-2 focus:outline-none focus:ring-1 focus:ring-green-500 font-medium"
              />
              <span className="absolute right-3 top-2.5 text-gray-500 text-sm font-medium">
                days
              </span>
            </div>
            <p className="text-xs text-gray-400 mt-0.5">
              Max Stock &lt; Calculation Period ≤ Last 90 Days
            </p>
          </div>

          {/* Seasonality in Demand Calculation */}
          <div className="border-2 hover:border-green-500 rounded-lg px-3 py-2 flex justify-between items-center select-none">
            <label className="font-semibold text-gray-800 text-sm">
              SEASONALITY IN DEMAND CALCULATION{" "}
          
            </label>

            {/* Toggle Switch */}
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" />
              <div className="w-11 h-6 bg-gray-300 rounded-full peer-checked:bg-green-700 transition-all duration-300"></div>
              <div className="absolute left-[2px] top-[2px] bg-white w-5 h-5 rounded-full transition-transform duration-300 peer-checked:translate-x-[20px]"></div>
            </label>
          </div>
        </div>

        {/* Footer Note */}
        <div className="bg-yellow-50 text-center py-2 text-sm border-t border-yellow-100">
          <span className="text-red-500 font-semibold">*</span>
          <span className="text-gray-700">
            Changes made here will come into effect after 12:00 am
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default ShortbookSettingsModal;
